import React, { useState } from "react";
import VersionModal from "./VersionModal";

// VERSION-SURFACING.md §4.2 — collapsed chip in the sidebar footer.
// Build-time env vars only; no network call to render. Click → modal.
//
// `minimal` renders the semver only — no git sha, no tier, no details modal.
// Used on pre-auth screens (login) so build provenance isn't exposed to
// anonymous visitors; the full badge is post-login only.
const VersionBadge: React.FC<{ minimal?: boolean }> = ({ minimal }) => {
  const [open, setOpen] = useState(false);

  const version = process.env.REACT_APP_VERSION ?? "0.0.0";
  const sha = process.env.REACT_APP_GIT_SHA ?? "dev";
  const tier = process.env.REACT_APP_ENV_TIER ?? "d1";

  if (minimal) {
    return (
      <span style={{ fontSize: 11, color: "#737373", lineHeight: 1.4 }}>
        v{version}
      </span>
    );
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Build info — click for details"
        style={{
          appearance: "none",
          background: "transparent",
          border: "1px solid rgba(0,0,0,0.12)",
          borderRadius: 4,
          padding: "2px 8px",
          fontSize: 11,
          color: "#737373",
          cursor: "pointer",
          fontFamily: "inherit",
          lineHeight: 1.4,
        }}
      >
        v{version} · <code style={{ fontSize: 11 }}>{sha}</code> · {tier}
      </button>
      {open && <VersionModal onClose={() => setOpen(false)} />}
    </>
  );
};

export default VersionBadge;
